import React from "react";
import { Modal } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./ModalConfirmSelect.less";

const ModalConfirmSendMail = ({ visible, onConfirm, onCancel, cusName, confirmLoading }) => {
    const { t } = useTranslation();

    return (
        <Modal
            title={null}
            open={visible}
            onOk={onConfirm}
            onCancel={onCancel}
            okText={t("modal.sendmail.confirm")}
            cancelText={t("modal.sendmail.cancel")}
            className="modal-confirm-select"
            centered
            width={350}
            okButtonProps={{
                className: "confirm-button",
                loading: confirmLoading
            }}
            cancelButtonProps={{
                className: "cancel-button"
            }}
        >
            <div className="modal-content">
                <div className="modal-header">
                    <div className="icon-wrapper">
                        <CheckCircleOutlined className="location-icon" />
                    </div>
                    <h3 className="modal-title">{t("modal.sendmail.title")}</h3>
                </div>
                <div className="modal-body">
                    <p className="confirmation-sendmail-text">
                        {t("modal.sendmail.content")} <strong>{cusName}</strong> ?
                    </p>
                </div>
            </div>
        </Modal>
    );
};

export default ModalConfirmSendMail;
